import {format} from 'date-fns';
import {nl} from 'date-fns/locale';

export const formatDate = (date: Date): string => {
    return format(date, 'yyyy-MM-dd', {locale: nl});
};

export const formatDateTime = (date: Date, showSeconds: boolean = true): string => {
    return format(date, showSeconds ? 'HH:mm:ss yyyy-MM-dd' : 'HH:mm dd-MM-yyyy', {locale: nl});
};

export const formatTime = (date: Date, showSeconds: boolean = true): string => {
    return format(date, showSeconds ? 'HH:mm:ss' : 'HH:mm', {locale: nl});
};

const formatDateTimeWithDayOfWeek = (date: Date): string => {
    return format(date, 'eeee dd MMMM yyyy', {locale: nl});
};

export const createValidDate = (dateInput: string | number): Date | undefined => {
    if (!dateInput) {
        return undefined;
    }
    const date = new Date(dateInput);
    return isNaN(date.getTime()) ? undefined : date;
};

export const formatToStartedSinceMessage = (startTime: string): string | undefined => {
    const startTimeDate = createValidDate(startTime);
    if (!startTimeDate) {
        return undefined;
    }
    const dateString = formatDateTimeWithDayOfWeek(startTimeDate);
    const timeString = formatTime(startTimeDate, false);
    return `Sinds ${dateString} om ${timeString} uur`;
};
